import React from 'react';

const ArticleModal = ({ article, onClose }) => {
    if (!article) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
            <div className="bg-white rounded-3xl max-w-4xl w-full max-h-[90vh] overflow-y-auto">
                <div className="sticky top-0 bg-white border-b border-[#E8E3DD] px-6 py-4 flex justify-between items-center">
                    <span className="text-sm text-[#6B7A6A] font-medium">{article.category}</span>
                    <button onClick={onClose} className="text-gray-400 hover:text-gray-600 text-2xl">
                        ×
                    </button>
                </div>

                <div className="p-8">
                    <h1 className="serif text-3xl md:text-4xl text-[#1C1917] mb-4">{article.title}</h1>

                    {article.readTime && (
                        <p className="text-sm text-gray-500 mb-6">{article.readTime} чтения</p>
                    )}

                    {article.cover && (
                        <div className={`h-64 mb-8 rounded-2xl ${article.cover}`}></div>
                    )}

                    <div className="prose prose-lg max-w-none text-gray-700 leading-relaxed">
                        {article.content}
                    </div>

                    {article.products && (
                        <div className="mt-8 pt-8 border-t border-[#E8E3DD]">
                            <h3 className="serif text-xl mb-4">Рекомендуемые препараты:</h3>
                            <div className="flex flex-wrap gap-2">
                                {article.products.map((product, idx) => (
                                    <span key={idx} className="px-4 py-2 bg-[#F5F0EB] rounded-full text-sm text-[#1C1917]">
                                        {product}
                                    </span>
                                ))}
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ArticleModal;